import React, { type ReactNode } from 'react';
import { useIntl } from 'react-intl-next';
import Button from '@atlaskit/button';
import { Flex, xcss } from '@atlaskit/primitives';
import { messages } from './messages';
import { WarningIllustration } from './warning-illustration';

export const ErrorPage = () => {
    const { formatMessage } = useIntl();

    return (
        <Flex columnGap="space.100" alignItems="center" justifyContent="center" direction="column" xcss={wrapperStyles}>
            <WarningIllustration />
            <>
                <h3>{formatMessage(messages.title)}</h3>
                <p>
                    {formatMessage(messages.description, {
                        link: (chunks: ReactNode[]) => (
                            <Button
                                appearance="link"
                                spacing="none"
                                onClick={() => {
                                    window.location.reload();
                                }}
                            >
                                {chunks}
                            </Button>
                        ),
                    })}
                </p>
            </>
        </Flex>
    );
};

const wrapperStyles = xcss({
    height: '100%',
});
